import React from 'react';
import styles from './Stepper.module.scss';

interface StepperProps {
  currentStep: number; // 1, 2, або 3
}

const Stepper: React.FC<StepperProps> = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Termin wizyty' },
    { number: 2, label: 'Ankieta' },
    { number: 3, label: 'Płatność' }
  ];

  return (
    <div className={styles.stepperContainer}>
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div className={styles.stepWrapper}>
            <div 
              className={`${styles.stepCircle} ${
                step.number === currentStep ? styles.active : styles.inactive
              }`}
            >
              <span className={styles.stepNumber}>{step.number}</span>
            </div>
            <div className={styles.stepLabel}>
              {step.label}
            </div>
          </div>
          {index < steps.length - 1 && (
            <div className={styles.connector} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Stepper; 